import type { CompanyAsTableViewModel, CompanyViewModel } from "@vintecc/capture-api-types/v1";

import { useAppStore } from "@/store/appStore";

export interface CompanyAsTableViewModelSubrows extends CompanyAsTableViewModel {
  subcompanies?: CompanyAsTableViewModelSubrows[];
}

export function getSubrows(companies: CompanyAsTableViewModelSubrows[]) {
  const recursiveGetSubrows = (companyId: number, companies: CompanyAsTableViewModelSubrows[]) => {
    return companies
      .filter((c) => c.company?.parentCompanyId === companyId && c.id !== c.company?.parentCompanyId)
      .map((c) => {
        c.subcompanies = recursiveGetSubrows(c.id!, companies);
        return c;
      })
      .sort((a, b) => b.subcompanies!.length! - a.subcompanies!.length!);
  };

  // get root companies, i.e. companies that are their own parent
  const rootCompanies = companies.filter((c) => c.company?.parentCompanyId === c.id || useAppStore.getState().currentCompany === c.company?.name);

  // Assign subcompanies to root companies
  for (const rootCompany of rootCompanies) {
    rootCompany.subcompanies = recursiveGetSubrows(rootCompany.id!, companies);
  }

  return rootCompanies;
}

export function toFlatCompanyList(companies: CompanyAsTableViewModelSubrows[]): CompanyAsTableViewModelSubrows[] {
  const flatArray: CompanyAsTableViewModelSubrows[] = [];
  companies.forEach((company) => {
    flatArray.push(company);
    if (company.subcompanies) {
      flatArray.push(...toFlatCompanyList(company.subcompanies));
    }
  });
  return flatArray;
}

export function convertCompanyAsTableViewModelToCompanyViewModel(company: CompanyAsTableViewModel): CompanyViewModel {
  return {
    name: company.company!.name!,
    parentCompanyId: company.company!.parentCompanyId!,
    enabled: company.company!.enabled!,
    autoLink: company.company!.autoLink!,
    companyTags: company.company!.companyTags!,
    dbEndpoint: company.company!.dbEndpoint!,
    grafanaEndpoint: company.company!.grafanaEndpoint!,
    installedApps: [],
    emailDomains: company.company!.emailDomains!,
    microsoftEnabled: company.company!.microsoftEnabled!,
    microsoftRequired: company.company!.microsoftRequired!,
    unsEnabled: company.company!.unsEnabled!,
  };
}
